import { render, staticRenderFns } from "./registerIndividual.vue?vue&type=template&id=884bd4ea&scoped=true&title=%3D"
import script from "./registerIndividual.vue?vue&type=script&lang=js"
export * from "./registerIndividual.vue?vue&type=script&lang=js"
import style0 from "./registerIndividual.vue?vue&type=style&index=0&id=884bd4ea&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884bd4ea",
  null
  
)

export default component.exports